import { useEffect, useState } from "react";

const columns = [
  {
    title: "题材频道",
    links: ["都市怪谈", "病态美学", "末日废土", "禁忌异闻", "暗黑心理", "硬核猎奇"],
  },
  {
    title: "内容专区",
    links: ["热门精选", "邪典剧场", "暗黑连载", "脑洞高概念", "本周排行", "最新上架"],
  },
  {
    title: "关于站点",
    links: ["关于我们", "内容原则", "读者口碑", "常见问题", "联系建议", "冷门推荐"],
  },
];

export default function Footer() {
  const [year] = useState(new Date().getFullYear());
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="bg-primary-950/70 border-t border-background-300/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <a href="#home" className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-600 flex items-center justify-center text-foreground-950 text-lg">
                <i className="ri-skull-2-line"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950 tracking-wide">
                歪歪漫画
              </span>
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              猎奇邪典 · 暗黑系 · 冷门脑洞
              <br />
              聚合阅读入口，一站看全不迷路。
            </p>
            <div className="flex gap-2">
              {["ri-wechat-line", "ri-qq-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
                <a
                  key={icon}
                  href="#about"
                  aria-label="社区链接"
                  className="w-9 h-9 rounded-md bg-background-200/50 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-background-200/80 transition-colors"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-950 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#hot" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-6 border-t border-background-300/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © {year} 歪歪漫画 · 猎奇邪典暗黑漫画聚合阅读入口
          </p>
          <p className="text-xs text-foreground-600">
            内容仅供阅读参考 · 尊重每一部作品的原创表达
          </p>
        </div>
      </div>

      {showTop && (
        <button
          type="button"
          aria-label="返回顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 w-11 h-11 rounded-md bg-primary-600 hover:bg-primary-500 text-foreground-950 flex items-center justify-center shadow-none transition-colors"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </footer>
  );
}